// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/styles/app.scss
// module id = 225
// module chunks = 0